var render = function render(){var _vm=this,_c=_vm._self._c;return _c('resource-collection',{scopedSlots:_vm._u([{key:"default",fn:function({item}){return [_c('user',{attrs:{"user":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }